document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.product-carousel');
  const prevArrow = document.querySelector('.prev-arrow');
  const nextArrow = document.querySelector('.next-arrow');

  if (carousel && prevArrow && nextArrow) {
    nextArrow.addEventListener('click', () => {
      carousel.scrollBy({
        left: 300, // Nilai scroll dalam piksel
        behavior: 'smooth'
      });
    });

    prevArrow.addEventListener('click', () => {
      carousel.scrollBy({
        left: -300, // Nilai scroll dalam piksel
        behavior: 'smooth'
      });
    });
  }
});